import React from 'react';
import { cn } from '../../utils/cn';
import Card from './Card';

export interface StatCardProps {
  label: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  /** Renders the value with the DFX5 brand gradient (gradient-text) instead of the solid foreground color. */
  accent?: boolean;
  /** Optional slot rendered below the value/sub, e.g. a sparkline chart. */
  spark?: React.ReactNode;
  className?: string;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, sub, accent = false, spark, className }) => {
  return (
    <Card className={cn('flex flex-col gap-2', className)}>
      <span className="text-xs font-semibold uppercase tracking-widest text-[var(--muted-foreground)]">
        {label}
      </span>
      <span
        className={cn(
          'font-mono tabular-nums text-2xl font-semibold',
          accent
            ? 'bg-[image:var(--brand-gradient)] bg-clip-text text-transparent'
            : 'text-[var(--foreground)]'
        )}
      >
        {value}
      </span>
      {sub && <span className="text-sm text-[var(--muted-foreground)]">{sub}</span>}
      {spark && <div className="mt-1">{spark}</div>}
    </Card>
  );
};

export default StatCard;
